export default __webpack_public_path__ + "static/media/registration-phone.eccc1710.png";